import { Select, MenuItem, InputAdornment } from '@mui/material';
import { InsightsDateRange } from '../../globalPrompts/insights/insightsTypes';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { TEST_DATE_RANGE_OPTIONS } from '@/testFeatures';

const DATE_OPTIONS: { value: InsightsDateRange; label: string }[] = [
    { value: 'last_1_hour', label: 'Last 1 hr' },
    { value: 'last_24_hours', label: 'Last 24 hours' },
    { value: 'last_7_days', label: 'Last 7 days' },
    { value: 'last_30_days', label: 'Last 30 days' },

    ...TEST_DATE_RANGE_OPTIONS,
];

type DateRangeSelectProps = {
    value: InsightsDateRange;
    isAnalyzing: boolean;
    onChange: (value: InsightsDateRange) => void;
};

// Bare select so it can sit inline in the insights banner's action row (next to
// Re-run analysis) instead of occupying its own row above the content.
const DateRangeSelect: React.FC<DateRangeSelectProps> = ({ value, isAnalyzing, onChange }) => (
    <Select
        disabled={isAnalyzing}
        size="small"
        sx={{ borderRadius: 2, bgcolor: 'background.paper' }}
        value={value}
        onChange={(event) => onChange(event.target.value as InsightsDateRange)}
        startAdornment={
            <InputAdornment position="start">
                <CalendarTodayIcon fontSize="small" />
            </InputAdornment>
        }
    >
        {DATE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        ))}
    </Select>
);

export default DateRangeSelect;
